import React from 'react';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import Section, { Title, Content } from './Section';
import CarPartsSearch from './CarPartsSearch';

const Grid = styled.div`
  ${breakpoints.medium`
        display: flex;
        margin: 0 -${p => p.theme.gutterSmall};
    `};
`;

const Column = styled.div`
  margin-bottom: 30px;

  ${breakpoints.medium`
        flex: 1;
        margin: 0 ${p => p.theme.gutterSmall};
    `};
`;

const ColumnTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.2px;
`;

const Box = styled.div`
  background: ${p => p.theme.colors.lightBg};
  padding: 34px 46px;
  flex: 1;
`;

export default function CarPartsSearchSection() {
  return (
    <Section>
      <Title>Søk etter bildeler</Title>

      <Content>
        <Grid>
          <Column>
            <ColumnTitle>Finn bildel via originalnummer</ColumnTitle>

            <Box>
              <CarPartsSearch
                label="Finn bildel via originalnummer"
                placeholder="Originalnummer…"
                buttonText="Søk"
              />
            </Box>
          </Column>

          <Column>
            <ColumnTitle>Finn bildel via lagernummer</ColumnTitle>

            <Box>
              <CarPartsSearch
                label="Finn bildel via lagernummer"
                placeholder="Lagernummer…"
                buttonText="Søk"
                type="lagernummer"
              />
            </Box>
          </Column>
        </Grid>
      </Content>
    </Section>
  );
}
